import { type NextRouter } from 'next/router'

import { commonData } from '@/data/common'

// Solved canonicalUrl by https://rishimohan.me/blog/nextjs-canonical-tag
export const getCanonicalUrl = (
  path: NextRouter['asPath'],
  language?: string
): string => {
  return `${commonData.baseUrl}${language ? `/${language}` : ''}${path === '/' ? '' : path}`.split(
    '?'
  )[0]
}
